// components/LegalDocument.jsx
import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { legalService } from 'Services/legalService';
import '../Forms/Multistep/multistep.css';
import './StoreTermsCondition.css';
import './LegalDocument.css';

const LegalDocument = ({ documentType, userType = 'all' }) => {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setLoading(true);
        let data;
        
        if (documentType === 'privacy_policy') {
          data = await legalService.getPrivacyPolicy(userType);
        } else if (documentType === 'terms_conditions') {
          data = await legalService.getTermsConditions(userType);
        }
        
        setDocument(data);
        setError(null);
      } catch (err) {
        setError('Failed to load document. Please try again later.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, [documentType, userType]);

  if (loading) {
    return (
      <div className="legal-document-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading document...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="legal-document-container">
        <div className="error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!document) {
    return null;
  }

  // Sanitize HTML - IMPORTANT: Allow anchor links and IDs
  const sanitizedContent = DOMPurify.sanitize(document.document_html, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'ol', 'li', 
      'strong', 'em', 'br', 'a', 'div', 'span', 'table', 'thead', 
      'tbody', 'tr', 'th', 'td', 'b', 'i', 'u', 'style'
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'class', 'id', 'style',
      'name', 'data-custom-class'
    ],
    // Important: Allow anchor links
    ALLOW_UNKNOWN_PROTOCOLS: false,
    ADD_ATTR: ['target']
  });

  return (
    <div 
      className="tc-content"
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};

export default LegalDocument;